import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('CoreMapboxMglMap', {
    ref: "twinMap",
    class: _vm.classObject,
    attrs: {
      "accessToken": _vm.mapAccessToken,
      "attributionControl": false,
      "interactive": _vm.mapInteractive
    },
    on: {
      "load": _vm.onMapLoaded,
      "moveend": _vm.processAnimationQueue
    }
  }, [(_vm.geoHistory || []).length > 1 ? _c('div', {
    staticClass: "mr-1",
    staticStyle: {
      "float": "right"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-arrow-circle-left"
    },
    on: {
      "click": _vm.historyIndexStepBack
    }
  }), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-arrow-circle-right"
    },
    on: {
      "click": _vm.historyIndexStepForward
    }
  })], 1) : _vm._e(), !_vm.hideFullScreenButton && !_vm.fullScreen ? _c('div', {
    staticClass: "ml-1"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-expand-arrows"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('expand');
      }
    }
  })], 1) : _c('div', {
    staticClass: "ml-1"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-compress-arrows-alt"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close-expanded');
      }
    }
  })], 1), !_vm.isNotIE11 ? _c('div', {
    staticClass: "pa-2 header-frame",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.mapAlertIE')) + "\n    ")]) : _vm._e(), !_vm.allowMultiCoordinates ? _c('MglMarker', {
    attrs: {
      "coordinates": _vm.markerCoordinates,
      "color": _vm.markerColor,
      "draggable": _vm.markerDraggable,
      "anchor": _vm.hasMapIconAttachment ? 'center' : _vm.hasMapMarkerIcon ? 'bottom-left' : 'bottom'
    },
    on: {
      "dragend": _vm.onMarkerDragged
    }
  }, [_vm.hasMapIconAttachment || _vm.hasMapMarkerIcon ? _c('span', {
    attrs: {
      "slot": "marker"
    },
    slot: "marker"
  }, [_vm.hasMapIconAttachment ? [_c('div', {
    staticClass: "markerIcon",
    style: `background-image: url('${_vm.mapMarkerIconUrl(_vm.dtwData)}')`
  })] : _vm.hasMapMarkerIcon ? [_c(VIcon, {
    staticClass: "markerPin",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-" + _vm._s(_vm.dtwData.faIcon))]), _c('span', {
    staticClass: "markerPinTitle"
  }, [_vm._v(_vm._s(_vm.dtwTitle))])] : _vm._e()], 2) : _vm._e()]) : _vm._l(_vm.geoCoordinates, function (marker, index) {
    return _c('MglMarker', {
      key: `marker_${index}`,
      attrs: {
        "coordinates": marker.coordinates,
        "title": marker.title,
        "color": _vm.markerColor,
        "draggable": _vm.markerDraggable,
        "anchor": _vm.hasMapIconAttachment ? 'center' : 'bottom'
      },
      on: {
        "dragend": _vm.onMarkerDragged
      }
    }, [_vm.multiCoordinatesIcon ? _c('span', {
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [[_c(VIcon, {
      staticClass: "markerPin",
      attrs: {
        "color": _vm.color
      }
    }, [_vm._v("fal fa-" + _vm._s(_vm.multiCoordinatesIcon))])]], 2) : _vm._e(), _c('MglPopup', {
      attrs: {
        "anchor": "top"
      }
    }, [_c(VCard, {
      staticClass: "popup-box"
    }, [_c('div', {
      staticClass: "popup-box",
      domProps: {
        "innerHTML": _vm._s(marker.message)
      }
    })])], 1)], 1);
  }), _vm._l(_vm.geoHistory, function (markerData, index) {
    return _c('MglMarker', {
      key: `history_marker_${index}`,
      attrs: {
        "coordinates": markerData.coordinates.coordinates,
        "title": _vm.localizeDate(markerData.date),
        "color": _vm.markerColor,
        "draggable": false,
        "anchor": "center"
      }
    }, [_c('span', {
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [[_c(VIcon, {
      staticClass: "markerPin",
      attrs: {
        "color": _vm.color,
        "x-small": ""
      }
    }, [_vm._v("fal fa-circle")])]], 2), _c('MglPopup', {
      attrs: {
        "anchor": "top"
      }
    }, [_c(VCard, {
      staticClass: "popup-box"
    }, [_c('div', {
      staticClass: "popup-box"
    }, [_vm._v("\n            " + _vm._s(_vm.localizeDate(markerData.date)) + "\n            "), markerData.floorDtwin ? [_c('p', [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.floorLabel')) + "\n                "), _c('a', {
      attrs: {
        "href": `/#/digitaltwin-mgmt/${markerData.floorDtwin.id}`,
        "target": "_blank"
      }
    }, [_vm._v("\n                  » " + _vm._s(markerData.floorDtwin.title) + " / " + _vm._s(markerData.floorDtwin.number) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(markerData.floorDtwin.id) + ")\n                ")])])] : _vm._e(), _vm._l(_vm.get(markerData, 'properties.zones') || [], function (twin, i) {
      return _c('ul', {
        key: `twin_zone_${i}`
      }, [_c('li', [_c('a', {
        attrs: {
          "href": `/#/digitaltwin-mgmt/${twin.id}`,
          "target": "_blank"
        }
      }, [_vm._v("\n                  » " + _vm._s(twin.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(twin.id) + ")\n                ")])])]);
    })], 2)])], 1)], 1);
  }), _c('MglNavigationControl', {
    attrs: {
      "position": "bottom-right"
    }
  })], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };